import React from "react";

import Background from "../../../assets/market/market-bg-01.png";

import GamePageLayout from "../GamePageLayout";

const MarketPage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("market-2")}
    >
      냉장고에 먹을 게 없다...
      <br />
      주말인데 장이나 볼까~
    </GamePageLayout>
  );
};

export default MarketPage1;
